/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const VisitIcon = ({ width = 24, height = 24, hidden = false, title = 'Visit' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M33 4H3a1 1 0 0 0-1 1v24a1 1 0 0 0 1 1h2.314a8.995 8.995 0 0 1 1.949-2H4V10h28v18h-3.437a9.453 9.453 0 0 1 2.024 2H33a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1Z"
    />
    <path
      d="M21.213 27.051v-1.674a1.159 1.159 0 0 1 .295-.747 8.842 8.842 0 0 0 2.01-5.517c0-4.175-2.214-6.508-5.56-6.508s-5.623 2.425-5.623 6.508a8.936 8.936 0 0 0 2.107 5.517 1.159 1.159 0 0 1 .295.747v1.667a1.15 1.15 0 0 1-1 1.16c-6.722.585-7.727 5.183-7.727 7 0 .2-.007.8-.007.8H30v-.8c0-1.738-1.187-6.32-7.788-6.99a1.155 1.155 0 0 1-.999-1.163Z"
    />
  </svg>`;
};
